import { render, staticRenderFns } from "./InvestorProfile.vue?vue&type=template&id=a0f18bb2&scoped=true"
import script from "./InvestorProfile.vue?vue&type=script&lang=js"
export * from "./InvestorProfile.vue?vue&type=script&lang=js"
import style0 from "./InvestorProfile.vue?vue&type=style&index=0&id=a0f18bb2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f18bb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0f18bb2')) {
      api.createRecord('a0f18bb2', component.options)
    } else {
      api.reload('a0f18bb2', component.options)
    }
    module.hot.accept("./InvestorProfile.vue?vue&type=template&id=a0f18bb2&scoped=true", function () {
      api.rerender('a0f18bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InvestorProfile.vue"
export default component.exports